export default __webpack_public_path__ + "static/media/bundleAssignments.08dddfac.svg";